import React, { Component } from "react";

export default class About extends Component {
  state = {
    chardsTexName: [
      ["html","85%",],
      ["css", '75%'],
      ["JavaScript", '55%'],
      ["Bootstrap", "87%"],
      ["sass | scss", "90%"],
      ["react", '78%']
    ],
  };
  render() {
    const { chardsTexName } = this.state;
    return (
      <section className="about">
        <div className="kirishSoz">
          <h1>about me </h1>
        </div>
        <div className="iAm">
          <h1 className="i_m">
            I` a Muhiddin and <span>web Deweleper</span>
          </h1>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea ipsum
            culpa cum illo odit saepe odio distinctio ratione tempora quo totam,
            eius, perferendis, eligendi optio et. Deserunt perspiciatis
            assumenda maiores obcaecati illo harum eligendi mollitia.
          </p>
        </div>
        <div className="linksBox">
          <ul className="myLinks_wraper">
            <li>
              <b>City:</b>
              <p>Beshariq</p>
            </li>
            <li>
              <b>Birthday:</b>
              <p>2 february 2005</p>
            </li>
            <li>
              <b>Telegram:</b>
              <a href="https://t.me/UZBcodersJunior">@UZBcodersJunior</a>
            </li>
            <li>
              <b>Age:</b>
              <p>17</p>
            </li>
            <li>
              <b>Tel</b>
              <p>+998 88 820 12 88</p>
            </li>
            <li>
              <b>GitHub:</b>
              <p><a href="https://github.com/muhiddin0">Muhiddin0</a></p>
            </li>
          </ul>
          <div className="btnGroup">
            <a href="#">download CV</a>
            <a href="#">hire me</a>
          </div>
        </div>
        <ul className="charts">
          {chardsTexName.map((card) => (
            <li key={card}>
              <div>
                <b>{card[0]}</b>
                <b>{card[1]}</b>
              </div>
              <span className={card[0]}></span>
            </li>
          ))}
        </ul>
        <div className="my_howrks">
          <h1 className="order_1" >Education</h1>
          <h1 className="order_3">Eprasion</h1>
          <ul className="order_2">
            <li>
              <div className="dateTutorial">
                <i className="fi-rr-calendar"></i>
                <p>2019 - 2021</p>
              </div>
              <h3>Mentor from Frontent</h3>
              <p>
                men mentor sifatida yoshlarga 
                web fahifalarni frontent qismini 
                yasashni o'rgata olaman
              </p>
            </li>
          </ul>
          <ul className="order_3">
            <li>
              <div className="dateTutorial">
                <i className="fi-rr-calendar"></i>
                <p>2019 - 2021</p>
              </div>
              <h3>I am working Frontent</h3>
              <p>
                men web ilovalarning frontent qismini responsive hamda chiroyli va zamonaviy qili yasay olaman
              </p>
            </li>
          </ul>
        </div>
      </section>
    );
  }
}
